<template>
  <div
    v-if="!item"
    class="px-3"
  >
    <div class="skeleton-item mb-2"></div>
  </div>

  <div
    v-else
    class="card-item-content"
  >
    <div class="info-text mb-1">ID: {{ tradingItem.tradingId }}</div>
    <div class="flex align-center trading-name mb-1">
      <div
        v-if="tradingItem.tradingSubmitStatusCd === 1"
        class="draft mr-1 text-bold text-10"
      >
        Draft
      </div>
      <div>{{ tradingItem.tradingName }}</div>
    </div>
    <div class="info-text">{{ tradingItem.companyShortName }}</div>
    <div class="update-date">{{ formattedDate }}</div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'TradingCard',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const formattedDate = computed(() => {
      return props.item.updateDate
        ? dayjs(props.item.updateDate).format('YYYY/MM/DD HH:mm')
        : '';
    });
    return {
      formattedDate,
      tradingItem: props.item,
    };
  },
});
</script>
<style scoped>
.draft {
  background-color: #6d717c;
  color: #FFF;
  border-radius: 2px;
  padding: 1px 4px;
}

.trading-name {
  font-weight: 600;
  font-size: 13px;
  color: #5e5873;
}

.info-text {
  color: #999;
  font-size: 11px;
}

.update-date {
  font-size: 11px;
  color: #bbb;
  text-align: right;
}

.skeleton-item {
  height: 70px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eeeeee 25%, #dddddd 37%, #eeeeee 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}


@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
